/*
 * A Livewire request that fails: a plain note instead of Livewire's error box (owner, 2026-10-28). Most come from a
 * page left open while the same thing changed elsewhere (approved on a phone, removed in another tab, a co-owner or an
 * admin acting): the page is opened afresh (Livewire.navigate) to show it as it is now, and the note shows again
 * after. Busy or broken just says so and stays. With APP_DEBUG (<html data-debug>) a server error keeps the box, for its details.
 */
import {Livewire} from "../../vendor/livewire/livewire/dist/livewire.esm";

export const AFTER_RELOAD = 'toast-after-reload';

const CHANGED = "That changed on another device or tab since this page opened. Here it is as it is now.";

const NOTES = {
    // [type, message, reload]
    401: ['info', 'You were signed out, perhaps on another device. Sign in to carry on.', true],
    403: ['info', CHANGED, true],
    404: ['info', CHANGED, true],
    410: ['info', CHANGED, true],
    419: ['info', 'This page was open a long while, so it has been refreshed. Please try again.', true],
    429: ['warning', 'Too many tries. Wait a minute, then try again.', false],
    503: ['warning', 'The site is being updated. Try again in a minute.', false],
};
const BROKEN = ['error', 'Something went wrong on our side. Please try again; if it keeps happening, contact us.', false];

let reloading = false;

Livewire.interceptRequest(({onError}) => onError(({response, preventDefault}) => {
    const status = response?.status ?? 0;
    if (response?.aborted || reloading || (status >= 500 && status !== 503 && document.documentElement.hasAttribute('data-debug'))) {
        return;
    }

    const [type, message, reload] = NOTES[status] ?? BROKEN;
    preventDefault();
    window.Toaster[type](message);

    if (reload) {
        reloading = true;
        // Kept only once the page is really swapped (the unsaved-changes guard may keep it: Stay)
        document.addEventListener('livewire:navigating', () => {
            try {
                sessionStorage.setItem(AFTER_RELOAD, JSON.stringify({type, message}));
            } catch {}
        }, {once: true});
        // The page afresh the way links open pages (wire:navigate): the bars stay, it cross-fades
        setTimeout(() => {
            reloading = false;
            Livewire.navigate(location.href);
        }, 1500);
    }
}));
